import { UserClientApp } from "@amzn/client-workbench-api-model";

import { Metrics } from "@/apis/Metrics";
import { LocaleCode } from "@/helpers/consent/consent";

export const RETRY_LIMIT = 3;
export const CLIENT_APP: UserClientApp = "DayOneOnboardingWizard";

export const TRANSIENT_ERROR_CODES = [
  408, // Request Timeout
  409, // Conflict
  423, // Locked
  429, // Limit Exceeded
  502, // Bad Gateway
  503, // Service Unavailable
  504, // Endpoint Request Timed-out
];

export enum BLOCKING_ERROR_TYPE {
  /** Early access error before Day1 */
  BeforeDay1 = "BeforeDay1",

  /** User progress errors or late access error after Day1 */
  NotDay1 = "NotDay1",

  /** Alias is not found for the NH */
  NoAlias = "NoAlias",

  /** The NH has been intentionally excluded from EZO */
  IntentionalDenial = "IntentionalDenial",

  /** The NH's record is missing critical data */
  MissingData = "MissingData",

  /** The NH's hiring country is not eligible for EZO */
  InvalidCountryCode = "InvalidCountryCode",

  /** The NH's job level / job family is not eligible for EZO */
  InvalidJobLevel = "InvalidJobLevel",

  /** EZO is administratively disabled for everyone */
  EzoDisabled = "EzoDisabled",

  /** The default generic Day1 blocking error. Also covers a missing start date — the user-visible treatment is identical so we don't branch separately. */
  Generic = "Generic",
}

export const API_METRICS_HANDLE =
  Metrics.publisherInstance.newChildActionPublisherForMethod("API");
